<template>
  <div id="home">
    <div class="box row1" style="padding: 10px 20px;">
      <el-row v-if="data.personal">
        <el-col :span="3" :offset="1" align="center">
          <el-image
            v-if="errorimg"
            class="photo"
            :src="data.personal.headImg"
            @error="imgerror($event)"
            fit="cover"
            lazy
          ></el-image>
          <el-image
            v-else
            class="photo"
            :src="serve + '/headImg/headImg.jpg'"
            fit="cover"
            lazy
          ></el-image>
          <div class="lv3Text" style="margin-top:5px;">{{data.personal.nickname}}</div>
        </el-col>
        <el-col :span="4" style="line-height:73px;color: #e2211c;">
          <span>余额:{{data.personal.balance}}</span>
        </el-col>
        <el-col :span="3" :offset="3">
          <router-link to="/user/safety/0">安全设置</router-link>
        </el-col>
        <el-col :span="3">
          <router-link to="/user/address/0">地址管理</router-link>
        </el-col>
        <el-col :span="3">
          <router-link to="/user/couponCenter">我的优惠券</router-link>
        </el-col>
        <el-col :span="3">
          <router-link to="/user/score/1">我的积分</router-link>
        </el-col>
        <el-col :span="3" style="line-height:74px;display:none">
          <el-button type="primary" round>每日签到</el-button>
        </el-col>
      </el-row>
    </div>

    <div class="box" style="margin-top: 20px">
      <div class="title">
        <el-row>
          <el-col :span="12">我的订单</el-col>
          <el-col :span="12" align="right" class="lv3Text viewAll">
            <router-link to="/user/orders/1">查看全部</router-link>
          </el-col>
        </el-row>
      </div>
      <div>
        <div v-for="(item,index) of data.order" :key="index" class="od-item">
          <div class="od-title">
            <span class="tx1">{{item.date}}</span>
            <span class="tx2">订单编号：{{item.orderCode}}</span>
          </div>
          <div class="content">
            <div v-for="(item2,index) of productArr[index]" :key="index">
              <el-row v-if="index<3">
                <el-col :span="10">
                  <div class="i1">{{item2.title.substr(0,20)}}</div>
                </el-col>
                <el-col :span="3">
                  <div class="i2">{{item2.item_no}}</div>
                </el-col>
                <el-col :span="3">
                  <div class="i2">x {{item2.number}}</div>
                </el-col>
                <el-col :span="3">
                  <div class="i3">{{item.statusTxt}}</div>
                </el-col>
                <el-col :span="3" v-if="index == 0">
                  <div style="height: 70px;padding-top: 15px;" class="od-menu-div">
                    <div class="od-menu" v-if="item.status==4">
                      <router-link :to="'/user/comment?id='+item.id" class="lv2Text">去评价</router-link>
                    </div>
                    <div class="od-menu">
                      <router-link :to="'/user/viewOrder/1?id='+item.id" class="lv2Text">查看详情</router-link>
                    </div>
                    <div class="od-menu" @click="canCancelOrder(item.id)" v-if="item.status==0">取消订单</div>
                    <div
                      class="od-menu lv2Text"
                      @click="delOrder2(item.id)"
                      v-if="item.status>=6"
                    >删除订单</div>
                  </div>
                </el-col>
              </el-row>
              <div v-if="index==3" class="more lv3Text">
                更多
                <i class="el-icon-d-arrow-right"></i>
              </div>
            </div>
          </div>
          <div class="bottom">
            <el-row>
              <el-col :span="15">
                <span>
                  商品件数：
                  <span class="red">{{item.count}} 件</span>
                </span>
                <span>
                  商品总价：
                  <span class="red">&yen; {{item.all_money}}</span>
                </span>
                <span>
                  活动优惠：
                  <span class="red">- &yen; 0</span>
                </span>
                <span>
                  运费：
                  <span class="red">&yen; {{item.express_money}}</span>
                </span>
              </el-col>
              <el-col :span="9" align="right">
                <span class="od-price">
                  应付总额：
                  <span>&yen;{{item.pay_money}}</span>
                </span>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
      <div v-if="data.order && data.order.length == 0" class="lv4Text empty">
        <i class="fas fa-box-open fa-lg"></i>没有订单
      </div>
    </div>
    <div class="box" style="margin-top: 20px">
      <div class="title">
        <el-row>
          <el-col :span="12">我收藏的商品</el-col>
          <el-col :span="12" align="right" class="lv3Text viewAll">
            <router-link to="/user/collections/1">查看全部</router-link>
          </el-col>
        </el-row>
      </div>
      <div class="row2">
        <el-row :gutter="20" v-if="data.collect">
          <el-col class="div" :span="5" v-for="(item,index) of data.collect" :key="index">
            <div class="item2">
              <router-link :to="'/product/'+item.product_id">
                <el-image
                  lazy
                  style="width:100%;height:172px"
                  :src="serve + '/'+item.images"
                  fit="cover"
                ></el-image>
              </router-link>
              <div class="title">
                <router-link :to="'/product/'+item.product_id">{{item.title}}</router-link>
              </div>
              <div class="price">&yen; {{item.selling_price}}</div>
            </div>
          </el-col>
        </el-row>
        <div v-if="data.collect && data.collect.length == 0" class="lv4Text empty">
          <i class="fas fa-box-open fa-lg"></i>没有商品
        </div>
      </div>
    </div>
    <div class="box" style="margin-top: 20px">
      <div class="title">
        <el-row>
          <el-col :span="12">我的足迹</el-col>
          <el-col :span="12" align="right" class="lv3Text viewAll">
            <div @click="goHistory">查看全部</div>
          </el-col>
        </el-row>
      </div>
      <div class="row2">
        <el-row :gutter="20" v-if="data.views">
          <el-col class="div" :span="5" v-for="(item,index) of data.views" :key="index">
            <div class="item2">
              <router-link :to="'/product/='+item.product_id">
                <el-image
                  lazy
                  style="width:100%;height:172px"
                  :src="serve + '/'+item.images"
                  fit="cover"
                ></el-image>
              </router-link>
              <div class="title">
                <router-link :to="'/product/'+item.product_id">{{item.title}}</router-link>
              </div>
              <div class="price">&yen; {{item.selling_price}}</div>
            </div>
          </el-col>
        </el-row>
        <div v-if="data.views && data.views.length == 0" class="lv4Text empty">
          <i class="fas fa-box-open fa-lg"></i>没有商品
        </div>
      </div>
    </div>

    <el-dialog title="取消订单" :visible.sync="delOrderDialog" width="50%" @closed="handleClose">
      <div>取消订单后，本单享有的优惠可能会一并取消，是否继续？</div>
      <div class="lv3Text" style="font-size:12px;margin-top: 10px;">请选择取消订单的原因（必选）：</div>
      <div class="reason">
        <el-row :gutter="20">
          <el-col :span="12">
            <button @click="delReason=1" :class="delReason==1?'active':''">配送信息有误</button>
          </el-col>
          <el-col :span="12">
            <button @click="delReason=2" :class="delReason==2?'active':''">商品买错了</button>
          </el-col>
          <el-col :span="12">
            <button @click="delReason=3" :class="delReason==3?'active':''">重复下单/误下单</button>
          </el-col>
          <el-col :span="12">
            <button @click="delReason=4" :class="delReason==4?'active':''">忘记使用优惠券/积分等</button>
          </el-col>
          <el-col :span="12">
            <button @click="delReason=5" :class="delReason==5?'active':''">其他渠道价格更低</button>
          </el-col>
          <el-col :span="12">
            <button @click="delReason=6" :class="delReason==6?'active':''">不想买了</button>
          </el-col>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="delOrderDialog = false">取 消</el-button>
        <el-button
          type="primary"
          @click="cancelOrder()"
          :loading="loading1"
          :disabled="delReason==null"
        >确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      //
      serve: this.$store.state.serve,
      
      data: [],
      orders: null,
      productArr: [],
      delOrderDialog: false,
      delId: null,
      delReason: null,
      loading: false,
      loading1: false,
      errorimg: true
    };
  },
  activated() {
    this.$store.state.user_location = "个人中心";
  },
  created() {
    this.geting();
  },
  methods: {
    imgerror(e) {
      if (e) {
        this.errorimg = false;
      }
    },
    geting() {
      this.axios
        .get(this.serve + "/personal/personal", {
          params: {
            mobile: this.$cookies.get("user"),
            token: this.$cookies.get("token")
          }
        })
        .then(res => {
          this.data = res.data.data;
          for (var item of this.data.order) {
            var l = this.productArr.length;
            var listObj = JSON.parse(item["product_list"]);
            this.productArr[l] = listObj;
            var res = this.dayjs
              .unix(item["create_time"])
              .format("YYYY-MM-DD HH:mm:ss");
            item["date"] = res;
            var totalNumber = 0;
            if (listObj) {
              for (var item2 of listObj) {
                totalNumber += parseFloat(item2.number);
              }
            }
            item["count"] = totalNumber;
            item["statusTxt"] = "";
            switch (item["status"]) {
              case "0":
                item["statusTxt"] = "待付款";
                break;
              case "1":
                item["statusTxt"] = "待发货";
                break;
              case "2":
                item["statusTxt"] = "待发货";
                break;
              case "3":
                item["statusTxt"] = "待收货";
                break;
              case "4":
                item["statusTxt"] = "待评价";
                break;
              case "5":
                item["statusTxt"] = "已完成";
                break;
              case "6":
                item["statusTxt"] = "已取消";
                break;
            }
          }
        });
    },
    //
    cancelOrder() {
      this.loading1 = true;
      this.axios
        .get(this.serve + "/personal/cancel_order", {
          params: {
            mobile: this.$cookies.get("user"),
            token: this.$cookies.get("token"),
            order_id: this.delId,
            cause: this.delReason
          }
        })
        .then(res => {
          if (res.data.status == "success") {
            this.loading1 = false;
            this.delOrderDialog = false;
            this.$message("订单已取消");
            this.tabDataFn();
          }
        });
    },
    canCancelOrder(id) {
      this.delOrderDialog = true;
      this.delId = id;
    },
    goHistory() {
      this.$router.push("/user/history/1");
    },
    delOrder() {
      //
      this.loading = true;
      this.axios
        .get(this.serve + "/personal/cancel_order", {
          params: {
            mobile: this.$cookies.get("user"),
            token: this.$cookies.get("token"),
            order_id: this.delId,
            cause: this.delReason
          }
        })
        .then(res => {
          if (res.data.status == "success") {
            this.delOrderDialog = false;
            this.loading = false;
            this.geting();
          }
        });
    },
    delOrder2(id) {
      //
      this.axios
        .get(this.serve + "/personal/del_order", {
          params: {
            mobile: this.$cookies.get("user"),
            token: this.$cookies.get("token"),
            order_id: id
          }
        })
        .then(res => {
          if (res.data.status == "success") {
            this.$message.error("订单已删除");
          }
        });
    },
    handleClose() {
      this.delId = null;
      this.delReason = null;
    },
    openDio(id) {
      this.delOrderDialog = true;
      this.delId = id;
    }
  }
};
</script>
<style lang="scss">
#home {
  .empty {
    padding: 40px 0;
    .fa-box-open {
      margin-right: 10px;
    }
  }
  .reason {
    padding: 20px 0;
  }
  .reason button {
    display: block;
    width: 100%;
    background-color: #fff;
    border: 1px solid #ddd;
    color: #666;
    line-height: 40px;
    margin-bottom: 20px;
    cursor: pointer;
  }
  .reason button.active {
    border: 1px solid #e2211c;
    color: #e2211c;
  }
  .box {
    .od-menu:hover {
      text-decoration: underline;
    }
    .od-menu {
      cursor: pointer;
    }
    .more {
      background-color: #f5f5f5;
      text-align: center;
      padding: 3px 0;
      font-size: 12px;
      border-bottom: 1px solid #ddd;
      cursor: pointer;
    }
    .more:hover {
      text-decoration: underline;
    }
    .viewAll {
      font-size: 12px;
      cursor: pointer;
    }
    .viewAll a {
      color: #909399;
    }
    .viewAll:hover {
      text-decoration: underline;
    }
    .red {
      color: #e2211c;
      margin-right: 10px;
    }
    .od-price span {
      color: #e2211c;
      font-weight: bold;
      font-size: 20px;
    }
    .od-price {
      margin-right: 20px;
    }
    .content .el-row {
      border-bottom: 1px solid #ddd;
    }
    .od-menu {
      line-height: 1.5em;
    }
    .i1 {
      color: #333;
      padding: 0 20px;
      line-height: 70px;
    }
    .i2 {
      color: #666;
      line-height: 70px;
    }
    .i3 {
      color: #e2211c;
      line-height: 70px;
    }
    .title {
      background-color: #eeeeee;
      padding: 10px 20px;
    }
    background-color: #fff;
    border: 1px solid #ddd;
    .photo {
      border-radius: 50%;
      overflow: hidden;
      height: 50px;
      width: 50px;
    }
    .od-title {
      background-color: #f5faf9;
      padding: 15px;
      border-bottom: 1px solid #ddd;
      font-size: 12px;
      .tx1 {
        color: #666666;
        margin-right: 10px;
      }
      .tx2 {
        color: #333333;
      }
    }
    .od-item {
      margin: 10px;
      border: 1px solid #ddd;
      margin-bottom: 20px;
      .bottom {
        padding: 20px;
      }
    }
  }
  .row1 {
    a {
      color: #606266;
      line-height: 74px;
    }
    a:hover {
      color: #e2211c;
    }
  }
  .item2 {
    border: 1px solid #ddd;
    text-align: center;
  }
  .row2 {
    padding: 20px;
  }
  .div {
    width: 20%;
  }
  .item2 {
    .title {
      background-color: transparent;
      line-height: 20px;
      height: 13px;
      overflow: hidden;
    }
    .title:hover {
      text-decoration: underline;
    }
    .price {
      color: #e2211c;
      padding: 5px 0;
    }
  }
}
</style>